"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.messages = void 0;
var _locales = require("../../utils/locales");
const messages = exports.messages = {
  [_locales.locales.en]: {
    password_suggestions: "Password suggestions",
    password: "Password",
    password_weak: "Weak",
    password_fair: "Fair",
    password_strong: "Strong",
    password_secure: "Secure",
    phrase1: "Use a few words, avoid common phrases",
    phrase2: "No need for symbols, digits, or uppercase letters",
    phrase3: "Add another word or two. Uncommon words are better.",
    phrase4: "Straight rows of keys are easy to guess",
    phrase5: "Short keyboard patterns are easy to guess",
    phrase6: "Use a longer keyboard pattern with more turns",
    phrase7: "Repeats like 'aaa' are easy to guess",
    phrase8: "Repeats like 'abcabcabc' are only slightly harder to guess than 'abc'",
    phrase9: "Avoid repeated words and characters",
    phrase10: "Avoid sequences",
    phrase11: "Recent years are easy to guess",
    phrase12: "Avoid recent years",
    phrase13: "Avoid years that are associated with you",
    phrase14: "Dates are often easy to guess",
    phrase15: "Avoid dates and years that are associated with you",
    phrase16: "This is a top-10 common password",
    phrase17: "This is a top-100 common password",
    phrase18: "This is a very common password",
    phrase19: "This is similar to a commonly used password",
    phrase20: "A word by itself is easy to guess",
    phrase21: "Names and surnames by themselves are easy to guess",
    phrase22: "Common names and surnames are easy to guess",
    phrase23: "Capitalization doesn't help very much",
    phrase24: "All-uppercase is almost as easy to guess as all-lowercase",
    phrase25: "Reversed words aren't much harder to guess",
    phrase26: "Predictable substitutions like '@' instead of 'a' don't help very much"
  },
  [_locales.locales.es]: {
    password_suggestions: "Sugerencias de contraseña",
    password: "Contraseña",
    password_weak: "Débil",
    password_fair: "Regular",
    password_strong: "Fuerte",
    password_secure: "Segura",
    phrase1: "Usa algunas palabras, evita frases comunes",
    phrase2: "No es necesario usar símbolos, dígitos o letras mayúsculas",
    phrase3: "Añade una o dos palabras más. Las palabras poco comunes son mejores.",
    phrase4: "Filas rectas de teclas son fáciles de adivinar",
    phrase5: "Patrones de teclado cortos son fáciles de adivinar",
    phrase6: "Usa un patrón de teclado más largo con más giros",
    phrase7: "Repeticiones como 'aaa' son fáciles de adivinar",
    phrase8: "Repeticiones como 'abcabcabc' son solo un poco más difíciles de adivinar que 'abc'",
    phrase9: "Evita palabras y caracteres repetidos",
    phrase10: "Evita secuencias",
    phrase11: "Los años recientes son fáciles de adivinar",
    phrase12: "Evita los años recientes",
    phrase13: "Evita años que estén asociados contigo",
    phrase14: "Las fechas son a menudo fáciles de adivinar",
    phrase15: "Evita fechas y años que estén asociados contigo",
    phrase16: "Esta es una contraseña común del top 10",
    phrase17: "Esta es una contraseña común del top 100",
    phrase18: "Esta es una contraseña muy común",
    phrase19: "Esto es similar a una contraseña comúnmente utilizada",
    phrase20: "Una palabra por sí sola es fácil de adivinar",
    phrase21: "Los nombres y apellidos por sí solos son fáciles de adivinar",
    phrase22: "Los nombres y apellidos comunes son fáciles de adivinar",
    phrase23: "La capitalización no ayuda mucho",
    phrase24: "Todo en mayúsculas es casi tan fácil de adivinar como todo en minúsculas",
    phrase25: "Las palabras al revés no son mucho más difíciles de adivinar",
    phrase26: "Las sustituciones predecibles como '@' en lugar de 'a' no ayudan mucho"
  },
  [_locales.locales.fr]: {
    password_suggestions: "Suggestions de mot de passe",
    password: "Mot de passe",
    password_weak: "Faible",
    password_fair: "Correct",
    password_strong: "Fort",
    password_secure: "Sécurisé",
    phrase1: "Utilisez quelques mots, évitez les phrases courantes",
    phrase2: "Pas besoin de symboles, de chiffres ou de lettres majuscules",
    phrase3: "Ajoutez un autre mot ou deux. Les mots rares sont mieux.",
    phrase4: "Les lignes droites de touches sont faciles à deviner",
    phrase5: "Les motifs de clavier courts sont faciles à deviner",
    phrase6: "Utilisez un motif de clavier plus long avec plus de virages",
    phrase7: "Les répétitions comme 'aaa' sont faciles à deviner",
    phrase8: "Les répétitions comme 'abcabcabc' sont seulement un peu plus difficiles à deviner que 'abc'",
    phrase9: "Évitez les mots et les caractères répétés",
    phrase10: "Évitez les séquences",
    phrase11: "Les années récentes sont faciles à deviner",
    phrase12: "Évitez les années récentes",
    phrase13: "Évitez les années qui sont associées à vous",
    phrase14: "Les dates sont souvent faciles à deviner",
    phrase15: "Évitez les dates et les années qui sont associées à vous",
    phrase16: "C'est un mot de passe courant du top 10",
    phrase17: "C'est un mot de passe courant du top 100",
    phrase18: "C'est un mot de passe très courant",
    phrase19: "Ceci est similaire à un mot de passe couramment utilisé",
    phrase20: "Un mot seul est facile à deviner",
    phrase21: "Les prénoms et noms seuls sont faciles à deviner",
    phrase22: "Les prénoms et noms communs sont faciles à deviner",
    phrase23: "La capitalisation n'aide pas beaucoup",
    phrase24: "Tout en majuscules est presque aussi facile à deviner que tout en minuscules",
    phrase25: "Les mots inversés ne sont pas beaucoup plus difficiles à deviner",
    phrase26: "Les substitutions prévisibles comme '@' au lieu de 'a' n'aident pas beaucoup"
  },
  [_locales.locales.pt]: {
    password_suggestions: "Sugestões de senha",
    password: "Senha",
    password_weak: "Fraca",
    password_fair: "Regular",
    password_strong: "Forte",
    password_secure: "Segura",
    phrase1: "Use algumas palavras, evite frases comuns",
    phrase2: "Não é necessário usar símbolos, dígitos ou letras maiúsculas",
    phrase3: "Adicione mais uma ou duas palavras. Palavras incomuns são melhores.",
    phrase4: "Linhas retas de teclas são fáceis de adivinhar",
    phrase5: "Padrões de teclado curtos são fáceis de adivinhar",
    phrase6: "Use um padrão de teclado mais longo com mais curvas",
    phrase7: "Repetições como 'aaa' são fáceis de adivinhar",
    phrase8: "Repetições como 'abcabcabc' são apenas um pouco mais difíceis de adivinhar do que 'abc'",
    phrase9: "Evite palavras e caracteres repetidos",
    phrase10: "Evite sequências",
    phrase11: "Anos recentes são fáceis de adivinhar",
    phrase12: "Evite anos recentes",
    phrase13: "Evite anos que estejam associados a você",
    phrase14: "Datas são frequentemente fáceis de adivinhar",
    phrase15: "Evite datas e anos que estejam associados a você",
    phrase16: "Esta é uma senha comum do top 10",
    phrase17: "Esta é uma senha comum do top 100",
    phrase18: "Esta é uma senha muito comum",
    phrase19: "Isto é semelhante a uma senha comumente usada",
    phrase20: "Uma palavra sozinha é fácil de adivinhar",
    phrase21: "Nomes e sobrenomes sozinhos são fáceis de adivinhar",
    phrase22: "Nomes e sobrenomes comuns são fáceis de adivinhar",
    phrase23: "A capitalização não ajuda muito",
    phrase24: "Tudo em maiúsculas é quase tão fácil de adivinhar quanto tudo em minúsculas",
    phrase25: "Palavras invertidas não são muito mais difíceis de adivinhar",
    phrase26: "Substituições previsíveis como '@' em vez de 'a' não ajudam muito"
  },
  [_locales.locales.zh]: {
    password_suggestions: "密码建议",
    password: "密码",
    password_weak: "弱",
    password_fair: "一般",
    password_strong: "强",
    password_secure: "安全",
    phrase1: "使用几个单词，避免常用短语",
    phrase2: "不需要使用符号、数字或大写字母",
    phrase3: "再添加一个或两个词。 不常见的单词更好。",
    phrase4: "连续的按键行很容易猜到",
    phrase5: "短的键盘模式很容易猜到",
    phrase6: "使用更长的键盘模式并有更多的转弯",
    phrase7: "像“aaa”这样的重复很容易猜到",
    phrase8: "像“abcabcabc”这样的重复仅比“abc”稍难猜到",
    phrase9: "避免重复的单词和字符",
    phrase10: "避免连续的序列",
    phrase11: "最近的年份很容易猜到",
    phrase12: "避免使用最近的年份",
    phrase13: "避免与您相关的年份",
    phrase14: "日期通常很容易猜到",
    phrase15: "避免与您相关的日期和年份",
    phrase16: "这是一个前 10 常用密码",
    phrase17: "这是一个前 100 常用密码",
    phrase18: "这是一个非常常用的密码",
    phrase19: "这与常用密码相似",
    phrase20: "单个单词很容易猜到",
    phrase21: "单个名字和姓氏很容易猜到",
    phrase22: "常见的名字和姓氏很容易猜到",
    phrase23: "大写不会有太大帮助",
    phrase24: "全大写几乎和全小写一样容易猜到",
    phrase25: "倒过来的单词并不难猜",
    phrase26: "像 '@' 代替 'a' 这样的可预测替换不太有帮助"
  },
  [_locales.locales.de]: {
    password_suggestions: "Passwortvorschläge",
    password: "Passwort",
    password_weak: "Schwach",
    password_fair: "Mittel",
    password_strong: "Stark",
    password_secure: "Sicher",
    phrase1: "Verwenden Sie ein paar Wörter, vermeiden Sie häufige Phrasen",
    phrase2: "Es sind keine Symbole, Ziffern oder Großbuchstaben erforderlich",
    phrase3: "Fügen Sie ein weiteres Wort oder zwei hinzu. Ungewöhnliche Wörter sind besser.",
    phrase4: "Gerade Tastenreihen sind leicht zu erraten",
    phrase5: "Kurze Tastaturmuster sind leicht zu erraten",
    phrase6: "Verwenden Sie ein längeres Tastaturmuster mit mehr Wendungen",
    phrase7: "Wiederholungen wie 'aaa' sind leicht zu erraten",
    phrase8: "Wiederholungen wie 'abcabcabc' sind nur etwas schwerer zu erraten als 'abc'",
    phrase9: "Vermeiden Sie wiederholte Wörter und Zeichen",
    phrase10: "Vermeiden Sie Sequenzen",
    phrase11: "Jüngste Jahre sind leicht zu erraten",
    phrase12: "Vermeiden Sie jüngste Jahre",
    phrase13: "Vermeiden Sie Jahre, die mit Ihnen verbunden sind",
    phrase14: "Daten sind oft leicht zu erraten",
    phrase15: "Vermeiden Sie Daten und Jahre, die mit Ihnen verbunden sind",
    phrase16: "Dies ist ein Top-10-Passwort",
    phrase17: "Dies ist ein Top-100-Passwort",
    phrase18: "Dies ist ein sehr häufig verwendetes Passwort",
    phrase19: "Dies ist ähnlich wie ein häufig verwendetes Passwort",
    phrase20: "Ein einzelnes Wort ist leicht zu erraten",
    phrase21: "Namen und Nachnamen allein sind leicht zu erraten",
    phrase22: "Häufige Namen und Nachnamen sind leicht zu erraten",
    phrase23: "Großschreibung hilft nicht sehr viel",
    phrase24: "Alles in Großbuchstaben ist fast so leicht zu erraten wie alles in Kleinbuchstaben",
    phrase25: "Umgekehrte Wörter sind nicht viel schwerer zu erraten",
    phrase26: "Vorhersehbare Ersetzungen wie '@' anstelle von 'a' helfen nicht viel"
  },
  [_locales.locales.it]: {
    password_suggestions: "Suggerimenti per la password",
    password: "Password",
    password_weak: "Debole",
    password_fair: "Discreto",
    password_strong: "Forte",
    password_secure: "Sicura",
    phrase1: "Usa qualche parola, evita frasi comuni",
    phrase2: "Non è necessario usare simboli, cifre o lettere maiuscole",
    phrase3: "Aggiungi un'altra parola o due. Le parole insolite sono migliori.",
    phrase4: "Righe dritte di tasti sono facili da indovinare",
    phrase5: "I modelli di tastiera corti sono facili da indovinare",
    phrase6: "Usa un modello di tastiera più lungo con più curve",
    phrase7: "Ripetizioni come 'aaa' sono facili da indovinare",
    phrase8: "Ripetizioni come 'abcabcabc' sono solo leggermente più difficili da indovinare di 'abc'",
    phrase9: "Evita parole e caratteri ripetuti",
    phrase10: "Evita sequenze",
    phrase11: "Gli anni recenti sono facili da indovinare",
    phrase12: "Evita gli anni recenti",
    phrase13: "Evita gli anni associati a te",
    phrase14: "Le date sono spesso facili da indovinare",
    phrase15: "Evita date e anni associati a te",
    phrase16: "Questa è una password comune nella top 10",
    phrase17: "Questa è una password comune nella top 100",
    phrase18: "Questa è una password molto comune",
    phrase19: "Questa è simile a una password comunemente usata",
    phrase20: "Una parola da sola è facile da indovinare",
    phrase21: "Nomi e cognomi da soli sono facili da indovinare",
    phrase22: "Nomi e cognomi comuni sono facili da indovinare",
    phrase23: "La capitalizzazione non aiuta molto",
    phrase24: "Tutto maiuscolo è quasi facile da indovinare quanto tutto minuscolo",
    phrase25: "Le parole invertite non sono molto più difficili da indovinare",
    phrase26: "Sostituzioni prevedibili come '@' invece di 'a' non aiutano molto"
  },
  [_locales.locales.ja]: {
    password_suggestions: "パスワードの提案",
    password: "パスワード",
    password_weak: "弱い",
    password_fair: "普通",
    password_strong: "強い",
    password_secure: "安全",
    phrase1: "いくつかの単語を使い、一般的なフレーズを避ける",
    phrase2: "記号、数字、大文字は必要ありません",
    phrase3: "もう一つか二つの単語を追加します。珍しい単語の方が良いです。",
    phrase4: "キーの直列は簡単に推測されます",
    phrase5: "短いキーパターンは簡単に推測されます",
    phrase6: "さらに曲がりくねった長いキーパターンを使用する",
    phrase7: "「aaa」のような繰り返しは簡単に推測されます",
    phrase8: "「abcabcabc」のような繰り返しは「abc」よりわずかに難しいです",
    phrase9: "繰り返される単語や文字を避ける",
    phrase10: "シーケンスを避ける",
    phrase11: "最近の年号は簡単に推測されます",
    phrase12: "最近の年号を避ける",
    phrase13: "自分に関連する年号を避ける",
    phrase14: "日付はしばしば簡単に推測されます",
    phrase15: "自分に関連する日付や年号を避ける",
    phrase16: "これはトップ10の一般的なパスワードです",
    phrase17: "これはトップ100の一般的なパスワードです",
    phrase18: "これは非常に一般的なパスワードです",
    phrase19: "これはよく使われるパスワードに似ています",
    phrase20: "単語だけで簡単に推測されます",
    phrase21: "名前や苗字だけでは簡単に推測されます",
    phrase22: "一般的な名前や苗字は簡単に推測されます",
    phrase23: "大文字にしてもあまり効果はありません",
    phrase24: "すべて大文字も、すべて小文字とほぼ同じくらい簡単に推測されます",
    phrase25: "逆さまにした単語はそれほど難しくありません",
    phrase26: "「@」のような予測可能な置換はあまり役に立ちません"
  },
  [_locales.locales.tl]: {
    password_suggestions: "Mga mungkahi ng password",
    password: "Password",
    password_weak: "Mahina",
    password_fair: "Katamtaman",
    password_strong: "Malakas",
    password_secure: "Ligtas",
    phrase1: "Gumamit ng ilang salita, iwasan ang mga karaniwang parirala",
    phrase2: "Walang kinakailangang mga simbolo, numero, o malalaking titik",
    phrase3: "Magdagdag ng isa o dalawang salita pa. Mas maganda ang hindi pangkaraniwang mga salita.",
    phrase4: "Ang mga sunud-sunod na hilera ng mga susi ay madaling hulaan",
    phrase5: "Ang mga maikling pattern ng keyboard ay madaling hulaan",
    phrase6: "Gumamit ng mas mahabang pattern ng keyboard na may higit pang mga liko",
    phrase7: "Ang mga pag-ulit tulad ng 'aaa' ay madaling hulaan",
    phrase8: "Ang mga pag-uulit tulad ng 'abcabcabc' ay bahagyang mas mahirap hulaan kaysa sa 'abc'",
    phrase9: "Iwasan ang mga nauulit na salita at character",
    phrase10: "Iwasan ang mga sequence",
    phrase11: "Madaling hulaan ang mga kamakailang taon",
    phrase12: "Iwasan ang mga kamakailang taon",
    phrase13: "Iwasan ang mga taon na nauugnay sa iyo",
    phrase14: "Madalas madaling hulaan ang mga petsa",
    phrase15: "Iwasan ang mga petsa at taon na nauugnay sa iyo",
    phrase16: "Ito ay isang nangungunang 10 karaniwang password",
    phrase17: "Ito ay isang nangungunang 100 karaniwang password",
    phrase18: "Ito ay isang napaka-karaniwang password",
    phrase19: "Ito ay katulad ng isang karaniwang ginagamit na password",
    phrase20: "Madaling hulaan ang isang salita lamang",
    phrase21: "Madaling hulaan ang mga pangalan at apelyido",
    phrase22: "Madaling hulaan ang mga karaniwang pangalan at apelyido",
    phrase23: "Ang capitalization ay hindi masyadong nakakatulong",
    phrase24: "Ang lahat ng malalaking titik ay halos kasing dali hulaan ng lahat ng maliliit na titik",
    phrase25: "Ang mga salitang binaliktad ay hindi masyadong mahirap hulaan",
    phrase26: "Ang mga mahuhulaan na pamalit tulad ng '@' sa halip na 'a' ay hindi masyadong nakakatulong"
  },
  [_locales.locales.hi]: {
    password_suggestions: "पासवर्ड सुझाव",
    password: "पासवर्ड",
    password_weak: "कमजोर",
    password_fair: "औसत",
    password_strong: "मजबूत",
    password_secure: "सुरक्षित",
    phrase1: "कुछ शब्दों का प्रयोग करें, सामान्य वाक्यांशों से बचें",
    phrase2: "प्रतीकों, अंकों या बड़े अक्षरों की आवश्यकता नहीं है",
    phrase3: "एक या दो और शब्द जोड़ें। असामान्य शब्द बेहतर होते हैं।",
    phrase4: "स्ट्रेट कीबोर्ड की पंक्तियों का अनुमान लगाना आसान होता है",
    phrase5: "छोटे कीबोर्ड पैटर्न का अनुमान लगाना आसान होता है",
    phrase6: "अधिक मोड़ के साथ लंबे कीबोर्ड पैटर्न का उपयोग करें",
    phrase7: "'aaa' जैसी पुनरावृत्तियों का अनुमान लगाना आसान होता है",
    phrase8: "'abcabcabc' जैसी पुनरावृत्तियों का अनुमान लगाना 'abc' की तुलना में केवल थोड़ा कठिन है",
    phrase9: "दोहराए गए शब्दों और वर्णों से बचें",
    phrase10: "अनुक्रमों से बचें",
    phrase11: "हाल के वर्षों का अनुमान लगाना आसान होता है",
    phrase12: "हाल के वर्षों से बचें",
    phrase13: "आपसे जुड़े वर्षों से बचें",
    phrase14: "तिथियों का अनुमान लगाना अक्सर आसान होता है",
    phrase15: "आपसे जुड़े तिथियों और वर्षों से बचें",
    phrase16: "यह शीर्ष 10 सामान्य पासवर्ड में से एक है",
    phrase17: "यह शीर्ष 100 सामान्य पासवर्ड में से एक है",
    phrase18: "यह एक बहुत ही सामान्य पासवर्ड है",
    phrase19: "यह सामान्यतः उपयोग किए जाने वाले पासवर्ड के समान है",
    phrase20: "एक शब्द का अनुमान लगाना आसान होता है",
    phrase21: "नाम और उपनाम अकेले का अनुमान लगाना आसान होता है",
    phrase22: "सामान्य नाम और उपनाम का अनुमान लगाना आसान होता है",
    phrase23: "कैपिटलाइज़ेशन बहुत अधिक मदद नहीं करता",
    phrase24: "सभी बड़े अक्षरों का अनुमान लगाना लगभग सभी छोटे अक्षरों के समान आसान होता है",
    phrase25: "उल्टे शब्दों का अनुमान लगाना बहुत मुश्किल नहीं होता",
    phrase26: "'a' के बजाय '@' जैसे पूर्वानुमेय प्रतिस्थापन बहुत अधिक मदद नहीं करते"
  },
  [_locales.locales.ko]: {
    password_suggestions: "비밀번호 제안",
    password: "비밀번호",
    password_weak: "약함",
    password_fair: "보통",
    password_strong: "강함",
    password_secure: "안전함",
    phrase1: "몇 가지 단어를 사용하고 일반적인 문구는 피하세요",
    phrase2: "기호, 숫자 또는 대문자는 필요하지 않습니다",
    phrase3: "단어를 하나 또는 두 개 더 추가하세요. 드문 단어가 더 좋습니다.",
    phrase4: "연속된 키는 추측하기 쉽습니다",
    phrase5: "짧은 키보드 패턴은 추측하기 쉽습니다",
    phrase6: "더 많은 회전이 있는 더 긴 키보드 패턴을 사용하세요",
    phrase7: "'aaa'와 같은 반복은 추측하기 쉽습니다",
    phrase8: "'abcabcabc'와 같은 반복은 'abc'보다 약간 더 추측하기 어렵습니다",
    phrase9: "반복된 단어와 문자를 피하세요",
    phrase10: "시퀀스를 피하세요",
    phrase11: "최근 몇 년은 추측하기 쉽습니다",
    phrase12: "최근 몇 년을 피하세요",
    phrase13: "자신과 관련된 연도를 피하세요",
    phrase14: "날짜는 종종 추측하기 쉽습니다",
    phrase15: "자신과 관련된 날짜와 연도를 피하세요",
    phrase16: "이것은 상위 10개의 일반적인 비밀번호 중 하나입니다",
    phrase17: "이것은 상위 100개의 일반적인 비밀번호 중 하나입니다",
    phrase18: "이것은 매우 일반적인 비밀번호입니다",
    phrase19: "이것은 일반적으로 사용되는 비밀번호와 유사합니다",
    phrase20: "단어 하나만으로 추측하기 쉽습니다",
    phrase21: "이름과 성만으로 추측하기 쉽습니다",
    phrase22: "일반적인 이름과 성은 추측하기 쉽습니다",
    phrase23: "대문자는 별로 도움이 되지 않습니다",
    phrase24: "모두 대문자로 된 것은 모두 소문자로 된 것만큼 추측하기 쉽습니다",
    phrase25: "뒤집힌 단어는 그렇게 추측하기 어렵지 않습니다",
    phrase26: "'a' 대신 '@'와 같은 예측 가능한 대체는 그다지 도움이 되지 않습니다"
  }
};